/* Everything Automotive — Service Worker registration
 * Lives at: frontend/src/serviceWorkerRegistration.js
 * Imported and called from src/index.js.
 *
 * CRITICAL RULE: the service worker must ONLY run in PRODUCTION builds.
 * In development (`npm start` / react-scripts) a service worker caches the
 * dev bundle and can serve stale chunks after a rebuild — which causes hard,
 * confusing crashes (e.g. duplicate React, "Invalid hook call"). So in dev
 * this file does the OPPOSITE of registering: it unregisters any previously
 * installed service worker on this origin and deletes its caches, healing
 * browsers that were already affected.
 *
 * This is the Create React App (react-scripts) variant:
 *   - production check uses process.env.NODE_ENV
 *   - the SW URL is built from process.env.PUBLIC_URL
 */

export function register() {
  if (!("serviceWorker" in navigator)) return;

  // --- DEVELOPMENT: never register; clean up any old SW + caches ---
  if (process.env.NODE_ENV !== "production") {
    devCleanup();
    return;
  }

  // --- PRODUCTION: register normally ---
  window.addEventListener("load", () => {
    const publicUrl = process.env.PUBLIC_URL || "";
    const swUrl = `${publicUrl}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        console.log("Everything Automotive SW registered:", registration.scope);
      })
      .catch((error) => {
        console.error("Everything Automotive SW registration failed:", error);
      });
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error));
  }
}

/* Removes every service worker registration and every cache on this origin.
 * Runs automatically in dev so localhost stops serving stale cached modules.
 * Reload once after this runs and the origin is clean. */
function devCleanup() {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      if (registrations.length === 0) return;
      console.warn(
        "[Everything Automotive DEV] Found",
        registrations.length,
        "service worker(s) on this origin — unregistering (service workers are production-only)."
      );
      return Promise.all(registrations.map((r) => r.unregister()));
    })
    .then(() => {
      if (!("caches" in window)) return;
      return caches.keys().then((keys) =>
        Promise.all(
          keys.map((key) => {
            console.warn("[Everything Automotive DEV] Deleting cache:", key);
            return caches.delete(key);
          })
        )
      );
    })
    .catch((error) => {
      console.error("[Everything Automotive DEV] SW cleanup failed:", error);
    });
}
